import React from 'react';

import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {bindActionCreators} from "redux";
import {fetchCurrentUser, updateCurrentUser, updateCurrentUserNotification} from "../../../../creators/currentUser";
import connect from "react-redux/es/connect/connect";
import {PageLoader} from "../../../components/Loader";
import {config} from "../../../../config";
import Helmet from "react-helmet";

import Toggle from "../../../components/Toggle";

class SettingsNotificationSettings extends React.Component {
    constructor(props) {
        super(props);
        this.notificationEmail = {
            //answersATopicIveParticipatedIn: true,
            topicFollow : true,
            commentMyStatus: true,
            commentOneOfMyArticles: true,
            commentOneOfMyMedias: true,
            commentOneOfMyTopics: true,
            commentStatusReply: true,
            followPostsANewMedia: true,
            followPostsANewTopic: true,
            requestAcceptedFriend: true,
            requestToAddsFriend: true,
            sendsNewMessageChatMyOffline: true,
            visitProfile: true,
            writesMyWall: true,
            newsletterMembers: true,
            newsletterPictures: true
        };
        this.notificationSite = {
            status: true,
            comment: true,
            like: true,
            topicFollow: true
        };
        this.state = {
            notificationEmail: this.notificationEmail,
            notificationSite : this.notificationSite
        };
        this.handleNotificationsEmail = this.handleNotificationsEmail.bind(this);
        this.handleNotificationsSite = this.handleNotificationsSite.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(oldProps) {
        this.props.fetchCurrentUser();
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let currentUser = newProps.currentUser;
            this.setState({
                notificationEmail: currentUser.notificationEmail,
                notificationSite: currentUser.notificationSite,
            });
        }
    }

    handleNotificationsEmail(field, value) {
        this.setState({
            notificationEmail: {
                ...this.state.notificationEmail,
                [field]: value
            }
        });
    }
    handleNotificationsSite(field, value) {
        this.setState({
            notificationSite: {
                ...this.state.notificationSite,
                [field]: value
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.updateCurrentUserNotification(this.state);
    }

    render() {
        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <div className="settings-wrapper">
                <Helmet>
                    <title>{config.preTitle}Options de notifications{config.postTitle}</title>
                </Helmet>

                <form onSubmit={(e) => this.handleSubmit(e)} className="block">
                    <div className="content">
                        <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Options de
                            Notifications</Title>
                        <h4>Notifications sur le site</h4>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un me demande en ami</label>
                            <Toggle
                                isToggled={this.state.notificationSite.requestToAddsFriend}
                                onToggle={() => this.handleNotificationsSite("requestToAddsFriend", !this.state.notificationSite.requestToAddsFriend)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Ma demande d'amitié a été acceptée</label>
                            <Toggle
                                isToggled={this.state.notificationSite.requestAcceptedFriend}
                                onToggle={() => this.handleNotificationsSite("requestAcceptedFriend", !this.state.notificationSite.requestAcceptedFriend)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un publie sur mon mur</label>
                            <Toggle
                                isToggled={this.state.notificationSite.status}
                                onToggle={() => this.handleNotificationsSite("status", !this.state.notificationSite.status)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un ajoute un commentaire sur mes photos, vidéos, articles, statuts</label>
                            <Toggle
                                isToggled={this.state.notificationSite.comment}
                                onToggle={() => this.handleNotificationsSite("comment", !this.state.notificationSite.comment)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un répond à un de mes commentaires</label>
                            <Toggle
                                isToggled={this.state.notificationSite.commentCitation}
                                onToggle={() => this.handleNotificationsSite("commentCitation", !this.state.notificationSite.commentCitation)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un like un de mes élements</label>
                            <Toggle
                                isToggled={this.state.notificationSite.like}
                                onToggle={() => this.handleNotificationsSite("like", !this.state.notificationSite.like)}/>
                        </div>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un participe à un topic que je suis</label>
                            <Toggle
                                isToggled={this.state.notificationSite.topicFollow}
                                onToggle={() => this.handleNotificationsSite("topicFollow", !this.state.notificationSite.topicFollow)}/>
                        </div>

                        <h4 className={"mt-16"}>Notifications par email</h4>
                        <div className="doubleCheckbox">
                            <label>Quelqu'un visite mon profil</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.visitProfile}
                                onToggle={() => this.handleNotificationsEmail("visitProfile", !this.state.notificationEmail.visitProfile)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un me demande en ami</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.requestToAddsFriend}
                                onToggle={() => this.handleNotificationsEmail("requestToAddsFriend", !this.state.notificationEmail.requestToAddsFriend)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Ma demande d'amitié a été acceptée</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.requestAcceptedFriend}
                                onToggle={() => this.handleNotificationsEmail("requestAcceptedFriend", !this.state.notificationEmail.requestAcceptedFriend)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un commente mon statut</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.commentMyStatus}
                                onToggle={() => this.handleNotificationsEmail("commentMyStatus", !this.state.notificationEmail.commentMyStatus)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un répond à un de mes messages posté sur un statut</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.commentStatusReply}
                                onToggle={() => this.handleNotificationsEmail("commentStatusReply", !this.state.notificationEmail.commentStatusReply)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un écrit sur mon mur</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.writesMyWall}
                                onToggle={() => this.handleNotificationsEmail("writesMyWall", !this.state.notificationEmail.writesMyWall)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Je suis hors ligne et quelqu'un envoie un nouveau message sur le chat</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.sendsNewMessageChatMyOffline}
                                onToggle={() => this.handleNotificationsEmail("sendsNewMessageChatMyOffline", !this.state.notificationEmail.sendsNewMessageChatMyOffline)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un commente l'un de mes médias</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.commentOneOfMyMedias}
                                onToggle={() => this.handleNotificationsEmail("commentOneOfMyMedias", !this.state.notificationEmail.commentOneOfMyMedias)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un commente l'un de mes articles</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.commentOneOfMyArticles}
                                onToggle={() => this.handleNotificationsEmail("commentOneOfMyArticles", !this.state.notificationEmail.commentOneOfMyArticles)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un répond à un sujet que j'ai créé</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.commentOneOfMyTopics}
                                onToggle={() => this.handleNotificationsEmail("commentOneOfMyTopics", !this.state.notificationEmail.commentOneOfMyTopics)}/>
                        </div>

                        {/*<div className="doubleCheckbox">
                            <label>Quelqu'un répond à un sujet auquel j'ai participé</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.answersATopicIveParticipatedIn}
                                onToggle={() => this.handleNotificationsEmail("answersATopicIveParticipatedIn", !this.state.notificationEmail.answersATopicIveParticipatedIn)}/>
                        </div>*/}

                        <div className="doubleCheckbox">
                            <label>Quelqu'un participe à un topic que je suis</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.topicFollow}
                                onToggle={() => this.handleNotificationsEmail("topicFollow", !this.state.notificationEmail.topicFollow)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un que je suis publie un nouveau média</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.followPostsANewMedia}
                                onToggle={() => this.handleNotificationsEmail("followPostsANewMedia", !this.state.notificationEmail.followPostsANewMedia)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Quelqu'un que je suis publie un nouveau sujet</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.followPostsANewTopic}
                                onToggle={() => this.handleNotificationsEmail("followPostsANewTopic", !this.state.notificationEmail.followPostsANewTopic)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Suggestion périodique de nouveaux membres à découvrir</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.newsletterMembers}
                                onToggle={() => this.handleNotificationsEmail("newsletterMembers", !this.state.notificationEmail.newsletterMembers)}/>
                        </div>

                        <div className="doubleCheckbox">
                            <label>Suggestion périodique de nouvelles photos à découvrir</label>
                            <Toggle
                                isToggled={this.state.notificationEmail.newsletterPictures}
                                onToggle={() => this.handleNotificationsEmail("newsletterPictures", !this.state.notificationEmail.newsletterPictures)}/>
                        </div>
                    </div>
                    <div className="settings-btn-group">
                        <Button size={"medium"}
                                btnType={"submit"}
                                loading={this.props.currentUserSubmitting}
                                btnStyle={"primary-reverse"}
                                content={"Enregistrer"}/>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser,
    updateCurrentUserNotification
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsNotificationSettings);
